'use strict';

import $ from 'jquery';
import Mustache from 'mustache';
import datalayerActions from './datalayer-actions';

let keyTimeout = null;
let trackTimeout = null;
let ajax = null;
let loaderVisible = false;
//const API = 'https://api.addsearch.com/v1/search/d59cfca9eb939ebf4c6ce722aaf44a48?limit=20&term=';
const API = '/stage-ajax/site-search/?search=';
const templateModal = $('#mustache-search-results-modal').html();
const templatePage = $('#mustache-search-results-page').html();
const searchPageUrl = '/hakutulokset/?search=';
const searchPageNames = ['hakutulokset'];
const GATrackingCode = 'UA-38663211-1';
let GACreated = null;

function init(){
  if( !isSearchPage() ){
    $('body').on('click', function(e){
      $('.navbar__search-results').removeClass('view');
      $('.navbar__search .icon-noun-close-white').css({
        'display': 'none'
      });
      loaderVisible = false;
      waitAnim(0);
    });

    $('body').on('click', '#navSiteSearch', function(e){
      e.stopPropagation();
      if( $('.navbar__search-results > *').length > 0 ){
        $('.navbar__search-results').addClass('view');
      }
      $('.navbar__search .icon-noun-close-white').css({
        'display': 'block'
      });
    });

    // Empty search field and modal search results
    $('body').on('click', '.navbar__search .icon-noun-close-white', function(){
      $('#navSiteSearch').val('');
      $('.navbar__search-results').empty().removeClass('view');
    });

  } else {
    //send search query to datalayer
    let searchvariable = getQueryVariable('search');
    if(searchvariable) {
      searchvariable = decodeURIComponent(searchvariable).split('+').join(' '); //decode string and replace all +-signs with spaces
      trackSearch(searchvariable);
    }
  }

  $('#navSiteSearch').on('click', function() {
    $('i.icon.icon-icon-search-white-bold').addClass('blink-off');
  });

  $('body').on('keyup', '#navSiteSearch', function(){
    clearTimeout(keyTimeout);
    clearTimeout(trackTimeout);

    var find = $(this).val();
    if( !loaderVisible ){
      loaderVisible = true;
      waitAnim(1);
    }

    if( find.length > 2 ){
      keyTimeout = setTimeout(function(){
        search(find);
        if( isSearchPage() ){
          var stateObj = {};
          history.replaceState(stateObj, '', '?search=' + find);
        }
      }, 500);

      trackTimeout = setTimeout(function(){
        trackSearch(find);
      }, 2000);

    }

  });

}

function waitAnim(show = 0){
  /*
    TODO: implement proper loader
  */
  if(show){
    //$('.navbar__search .icon-noun-close-white').addClass('rotate');
    $('.navbar__search-container').addClass('loading');
  }
  else{
    //$('.navbar__search .icon-noun-close-white').removeClass('rotate');
    $('.navbar__search-container').removeClass('loading');
  }
}

function search(find) {

  const categoryConfig = [
    {name: "blog", showAmount: 4},
    {name: "site", showAmount: 4},
    {name: "cars", showAmount: 6},
    {name: "dealers", showAmount: 4},
    {name: "contacts", showAmount: 4}
  ];

  if(ajax && ajax.readyState !== 4){
    return false;
  }
  ajax = $.ajax({
    url: API + find,
    crossDomain: true,
    success: function(data){

      if( isSearchPage() ){
        $('#searchResults').html(Mustache.render(templatePage, data));
      } else {

        //boolean values for search results
        data.hasResults = { any: data.total_hits === 0 || Object.keys(data.hits).length === 0 ? false : true };

        categoryConfig.forEach((category) => {
          //if has results
          if (typeof data.hits[category.name] !== 'undefined' && data.hits[category.name].length > 0) {
            data.hasResults[category.name] = true; //add property to hasresults object
            //limit results for modal
            if(data.hits[category.name].length > category.showAmount) {
              data.hits[category.name] = data.hits[category.name].slice(0, category.showAmount);
            }
          }
        });

        $('.navbar__search-results').html(Mustache.render(templateModal, data));
        $('.navbar__search-results').addClass('view');

        //submit form on 'show more'-link
        $('.navbar__search-results').find('.show-more').on('click', function(e){
          $('.navbar__search-container form').submit();
        });
      }
      waitAnim(0);

      // Add GA pageview event if search is execuetd with ajax
      GAPageView(find);

      loaderVisible = false;
    }
  });

}

function trackSearch(find) {
  //push search event details to Datalayer
  const searchEvent = {
    eventCategory: 'Usability',
    eventAction: 'Sivustohaku',
    eventLabel: find
  };
  datalayerActions.pushEventToDatalayer(searchEvent);
}

function getQueryVariable(variable)
{
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    const pair = vars[i].split("=");
    if(pair[0] == variable){
      return pair[1];
    }
  }
  return(false);
}

function isSearchPage(){
  let res = false;
  //if page name is in the searchPageNames array
  if(searchPageNames.indexOf(window.location.href.split('/')[3]) > -1){
    res = true;
  }
  return res;
}


/**
  * Trigger GA pageview event
  *
  * @param {String} searchKeywords - Search keyword
  * @returns {Boolean} - True if ga object is available
*/
function GAPageView(searchKeywords){
  if( typeof window.ga !== 'undefined' && window.ga ){

    if( !GACreated ){
      window.ga('create', GATrackingCode, 'auto');
      GACreated = true;
    }

    window.ga('send', 'pageview', searchPageUrl + searchKeywords);
    return true;
  }
  return false;
}

export default { init };
export { init };
